{
  "generating": "Generating",
  "reviewTrades": "Review Trades",
  "updateTrades": "Update Trade Fills",
  "completed": "Completed",
  "generatingDescription": "Trades are being generated now...",
  "rebalanceOn": "Rebalance on",
  "rebalanceCanceled": "Rebalance is canceled, go back to start a new one.",
  "buyTradeFile": "Download Buy Trade File",
  "sellTradeFile": "Download Sell Trade File",
  "mutualFundTradeFile": "Download Mutual Fund Trade File",
  "ptfBulkTradeFile": "Download PTF Bulk Trade File",
  "tradeViaFix": "Trade Via FIX",
  "bulkBUYTrades": "Bulk Buy Trades",
  "bulkSELLTrades": "Bulk Sell Trades",
  "cancelRebalanceTrades": "Cancel Rebalance Trades",
  "rebalanceCompleted": "Rebalance Completed",
  "allPricesNotUpdated": "All prices are not updated yet",
  "pasteFromExcel": "Copy/Paste from Excel",
  "orderOfContent": "Ensure columns are in order of ticker, price, quantity",
  "cancelConfirmationDialog": "Before you cancel, ensure that you have not sent the bulk trades files. If you have already sent the bulk trade files, the system will throw an ERROR, as all of those trades have been sent to the custodian.",
  "cancelTriggeredMessage": "Cancellation of Rebalance trades, has been triggered!",
  "discrepancyConfirmationDialog": {
    "title": "Discrepancies in Bulk Trades",
    "text": "There are relevant discrepancies in the allocated quantities or prices. Are you sure you want to proceed?"
  },
  "orderOfPortfolioContent": "Ensure columns are in order of ticker and percentage",
  "generate": "Generate"
}
